import React, {useState, useEffect} from 'react';
import {InputLabel, Select, MenuItem, Button, Grid, Typography} from '@material-ui/core';
import { useForm, FormProvider } from 'react-hook-form';
import { Link } from 'react-router-dom';

import FormInput from './FormInput';
import { commerce } from '../../lib/commerce';

const AddressForm = ({ checkoutToken, next }) => {
    const [shippingCountries, setShippingCountries] = useState([]);
    const [shippingCountry, setShippingCountry] = useState('');
    const [shippingSubdivisions, setShippingSubdivisions] = useState([]);
    const [shippingSubdivision, setShippingSubdivision] = useState('');
    const [shippingOptions, setShippingOptions] = useState([]);
    const [shippingOption, setShippingOption] = useState('');
    const methods =useForm();

    const countries =   Object.entries(shippingCountries).map( ([code, name])=> ({id: code, label: name}));
    //console.log('[AddressForm.jsx]-just set countries to :', countries);
    const subdivisions = Object.entries(shippingSubdivisions ).map( ([code, name])=> ({id: code, label: name}));
    console.log('[AddressForm.jsx]-just set subdivisions to :', subdivisions);
    const options = shippingOptions.map( (ShipOpt) => ({
        id: ShipOpt.id,  
        label: `${ShipOpt.description} - (${ShipOpt.price.formatted_with_symbol}) `
    }) )
    //console.log('[AddressForm.jsx]-just set options to :', options);



    const fetchShippingCountries  = async (checkoutTokenId) => {
        const { countries } = await commerce.services.localeListShippingCountries(checkoutTokenId);
        //console.log('[AddressForm.jsx]-got countries (from localeListShippingCountries) :', countries);
        setShippingCountries(countries);
        setShippingCountry(Object.keys(countries)[0]);
        //console.log('[AddressForm.jsx]-got ShippingCountry :', shippingCountry);
    }

    const fetchSubdivisions  = async (countryCode) => {
        const { subdivisions } = await commerce.services.localeListSubdivisions(countryCode);
        console.log('[AddressForm.jsx-fetchSubdivisions]-got subdivisions :', subdivisions);
        setShippingSubdivisions(subdivisions);
        //console.log('[AddressForm.jsx-fetchSubdivisions]-Object.keys(subdivisions)[0] is :', Object.keys(subdivisions)[0]);
        setShippingSubdivision(Object.keys(subdivisions)[0]);
    }

    const fetchShippingOptions = async (checkoutTokenId, country, region = null ) => {
        console.log('[AddressForm.jsx-fetchShippingOptions]-got :', checkoutTokenId, "country : ", country, "stateProvince :", region  );
        const options = await commerce.checkout.getShippingOptions( checkoutTokenId, {country , region });
        console.log('[AddressForm.jsx-fetchShippingOptions]-got options :', options);
        if(options.length >0 ){
            setShippingOptions(options);
        //console.log('[AddressForm.jsx-fetchShippingOptions]-got options :', options);
            setShippingOption(options[0].id); // bug ?
        } else { // bug - 0 ptions were retrieved
            setShippingOptions([{id: 0, description: "none", 
            price : {
                formatted_with_symbol: "Euro"
            }}]);
            setShippingOption("No Shipping Option Retrieved"); 
        }
    }

    useEffect(() => {
        fetchShippingCountries(checkoutToken.id);
    },[]);
    
    useEffect(() => {
        if (shippingCountry) {
            fetchSubdivisions(shippingCountry)
            //console.log('[AddressForm.jsx-UseEffect]-shippingCountry changed, called fetchSubdivisions');
        };
    },[shippingCountry]);

    useEffect(() => {
        if (shippingSubdivision) {
            console.log('[AddressForm.jsx-useEffect3]- will call  fetchShippingOptions with pararms :', checkoutToken.id, shippingCountry, shippingSubdivision);
            fetchShippingOptions(checkoutToken.id, shippingCountry, shippingSubdivision )
            //console.log('[AddressForm.jsx-UseEffect]-shippingCountry changed, called fetchSubdivisions');
        };
    },[shippingSubdivision]);

    return (
        <>
            <Typography variant='h6' gutterBottom>Shipping Address</Typography>
            <FormProvider {...methods}>
                <form onSubmit={methods.handleSubmit( (data)=> next(
                    {...data, shippingCountry,shippingSubdivision,shippingOption })
                 )}>
                    <Grid container spacing={3}>
                        <FormInput name='firstName' label ='First Name' />
                        <FormInput name='lastName' label ='Last Name' />
                        <FormInput name='address1' label ='Address' />
                        <FormInput name='email' label ='Email' />
                        <FormInput name='city' label ='City' />
                        <FormInput name='zip' label ='Zip / Postal code' />
                        <Grid item xs={12} sm={6}>
                            <InputLabel>Shipping Country</InputLabel>
                            <Select value={shippingCountry} fullWidth onChange={ (e) => 
                                setShippingCountry(e.target.value)
                            }>
                                { countries.map((country) => (
                                    <MenuItem key={country.id} value ={country.id}>
                                        {country.label}
                                    </MenuItem>
                                ))}
                            </Select>
                        </Grid>
                     
                        <Grid item xs={12} sm={6}>
                            <InputLabel>Shipping Subdivision</InputLabel>
                            <Select value={shippingSubdivision} fullWidth onChange={ (e) => 
                                setShippingSubdivision(e.target.value)
                            }>
                                {subdivisions.map((subdivision) => (
                                    <MenuItem key={subdivision.id} value ={subdivision.id}>
                                        {subdivision.label}
                                    </MenuItem>
                                ))}
                            </Select>
                        </Grid> 
                        <Grid item xs={12} sm={6}>
                            <InputLabel>Shipping Options</InputLabel>
                            <Select value={shippingOption} fullWidth onChange={ (e) => 
                                setShippingOption(e.target.value)
                            }>
                                 {options.map((option) => (
                                    <MenuItem key={option.id} value ={option.id}>
                                        {option.label}
                                    </MenuItem>
                                ))}
                            </Select>
                        </Grid>
                    </Grid>
                    <br />
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Button component={Link} to="/cart" variant="outlined">Back to Cart</Button>
                        <Button type="submit" variant="contained" color="primary">Next</Button>
                    </div>
                </form>
            </FormProvider>
        </>
    )
}

export default AddressForm;
